import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions';
import Main from './Main';

import './App.css';

const App = (props) => (
  <Main />
);

function mapStateToProps(state, ownProps){
  return {
    currentUser: state.currentUser.user,
    accessToken: state.currentUser.accessToken
  };
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(actions, dispatch)
    // echoToken: token => dispatch(actions.echoToken(token)),
    // setTokens: (accessToken, refreshToken) => dispatch(actions.setTokens({accessToken, refreshToken}))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js